import React from 'react';
import * as Styled from './AScrim.styles';
import { AScrimProps, AScrimIntensity } from './AScrim.types';

const COMPONENT_NAME = 'a-web-ui-kit-AScrim';
const TEST_ID = 'web-ui-kit-AScrim';

export const AScrim = React.memo(function AScrim({ intensity = AScrimIntensity.Full, ...rest }: AScrimProps) {
  return (
    <Styled.Wrapper
      {...rest}
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      aria-hidden="true"
      role="presentation"
      $intensity={intensity}
    />
  );
});

export { AScrimIntensity, TEST_ID as A_SCRIM_TEST_ID };
